module.exports = __webpack_public_path__ + "static/img/car.06218696.svg";